<template>
  <div>
    <div class="page-title">Edit UGC Submission</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update UGC Submission"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.submission.page";

export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.submission_form?.id;
    return {
      title: subject ? `Edit Submission: ${subject}` : `Edit Submission`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Submission.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      let uploadData = null;
      for (const [key, value] of Object.entries(this.form.data)) {
        if (value instanceof File && value.background_styles) {
          uploadData = uploadData || {};
          uploadData[key] = {
            background_styles: value.background_styles,
          };
        }
      }
      if (uploadData) this.form.upload_data = uploadData;
      await this.$api.Submission.update(this.form);
      this.$router.push("/widgets/submission-forms");
    },
  },
};
</script>

<style></style>
